// extracted by mini-css-extract-plugin
module.exports = {"showMore":"style_showMore__1Pdci","modal":"style_modal__1CQQr","contacts":"style_contacts__8t37D"};